"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useChanged;

var _react = require("react");

function useChanged(value) {
  var prevValueRef = (0, _react.useRef)(value);
  var changed = value !== prevValueRef.current;
  prevValueRef.current = value;
  return changed;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9ob29rcy9pbnRlcm5hbC91c2VDaGFuZ2VkLmpzIl0sIm5hbWVzIjpbInVzZUNoYW5nZWQiLCJ2YWx1ZSIsInByZXZWYWx1ZVJlZiIsImNoYW5nZWQiLCJjdXJyZW50Il0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7O0FBRWUsU0FBU0EsVUFBVCxDQUFvQkMsS0FBcEIsRUFBMkI7QUFDeEMsTUFBTUMsWUFBWSxHQUFHLG1CQUFPRCxLQUFQLENBQXJCO0FBQ0EsTUFBTUUsT0FBTyxHQUFHRixLQUFLLEtBQUtDLFlBQVksQ0FBQ0UsT0FBdkM7QUFFQUYsRUFBQUEsWUFBWSxDQUFDRSxPQUFiLEdBQXVCSCxLQUF2QjtBQUVBLFNBQU9FLE9BQVA7QUFDRCIsInNvdXJjZVJvb3QiOiJjb21wb25lbnQ6Ly8vIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgdXNlUmVmIH0gZnJvbSAncmVhY3QnO1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiB1c2VDaGFuZ2VkKHZhbHVlKSB7XG4gIGNvbnN0IHByZXZWYWx1ZVJlZiA9IHVzZVJlZih2YWx1ZSk7XG4gIGNvbnN0IGNoYW5nZWQgPSB2YWx1ZSAhPT0gcHJldlZhbHVlUmVmLmN1cnJlbnQ7XG5cbiAgcHJldlZhbHVlUmVmLmN1cnJlbnQgPSB2YWx1ZTtcblxuICByZXR1cm4gY2hhbmdlZDtcbn1cbiJdfQ==